import { makeCygnusApiCall } from "../../../api/api";
import { CustomToaster } from "../../../pages/reusable_components/Toasters/toaster";
import type { Approver } from "../../../Reusables/components/ClientApproverSetting/ClientApproverSetting.utils";

/**
 * Fetches all forms (client forms) available to the user.
 * 
 * Displays a toaster if no forms are available and prompts the user to create one.
 * 
 * @returns {Promise<any[] | undefined>} An array of form records if successful, otherwise undefined.
 */
export const fetchForms = async () => {
  const data = await makeCygnusApiCall({
    type: "GET",
    url: `/forms/`,
    show_message: true,
    customized_success_message: "Fetched your client data",
    customized_failure_message:
      "Unable to update your client, please try again. If the problem persists, please contact support and attach a screenshot.",
    customized_error_message:
      "Error occured while saving the updated client details, please contact support and attach a screenshot.",
    isblob: false,
    forMDM: true
  });

  if (data.success) {
    if (data.data.length > 0) {
      return data.data; // Return form list if available
    } else {
      // Show error if no forms are found
      CustomToaster({
        type: "error",
        customized_message:
          "You do not have any onboarding forms designed yet. Please create an onboarding form to use this feature.",
        api_message: "",
      });
      return data.data;
    }
  }
};

export async function getApproversList(
  clientMasterId: number,
  clientTypeCode: string | number | null
): Promise<Approver[]> {
  const endpoint = clientMasterId
    ? `/form/clientapprovers/?ClientMasterId=${clientMasterId}`
    : `/form/approvalsetting/?ClientTypeCode=${clientTypeCode}`;

  const res = await makeCygnusApiCall({
    type: "GET",
    payload: {},
    url: endpoint,
    show_message: false,
    isblob: false,
    forMDM: true,
  });

  const raw: Approver[] = Array.isArray(res?.data) ? (res.data as Approver[]) : [];
  const active = raw.filter((a) => String(a?.Active ?? "").toUpperCase() === "Y");

  return active;
}
